import pdfMake from 'pdfmake';
import handlePurchase from "@/services/modules/purchase";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { toCapitalizeFirst, formatNameWithCodes } from '@/services/utils/global.js'
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {

    const {formatCurrency, currencyToWord} = handlePurchase();
    const shouldInclude = (customizationFields, key) => !customizationFields || Object.keys(customizationFields).length === 0 || customizationFields[key];
    const shouldIncludeSignature = (customizationFields, key) => !!customizationFields && customizationFields[key] === true;
    const exportToPDF = (company, invoice, barcode = '', qrcode, userName, btnFunc, isReturn, customizationFields = {}, isDynamic = false) => {
        const tableItems = invoice.has_item_detail ? invoice.general : invoice.ledgers;
        const footerBottomMargin = isDynamic ? 165 : 120
        var doc = {
            pageSize: 'A4',
            pageMargins: [ 60, 100, 60, footerBottomMargin ],
            header: getHeader(company, customizationFields),
            footer: (currentPage, pageCount) => getFooter(userName, qrcode, customizationFields, invoice, isDynamic, currentPage, pageCount),
            content: getContent(invoice, tableItems, barcode, btnFunc, isReturn, customizationFields),

            styles : {
                header: {
                    fontSize: 24,
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 9,
                font: 'SulaimanLipi'
            },
            info: {
                title: invoice.bill_number
            }
        }

        pushIntoTable(doc, invoice, tableItems, btnFunc, customizationFields)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }
    const formatDate = (date) => {
        var formattedDate = date.toISOString().split('T')[0];
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
        return formatToDdMmYy(formattedDate) + ' ' + formattedTime
    }
    const formatToDdMmYy = (date) => {
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }
    const getHeader = (company, customizationFields) => {
        return {
            margin: [ 60, 25, 60, 10 ],
            columns: [
                {
                    alignment: 'left',
                    image: shouldInclude(customizationFields, 'heading_left_logo') ? company.logo64 : '',
                    maxHeight: 60
                },

                {
                    alignment: 'right',
                    stack: [
                        shouldInclude(customizationFields, 'heading_right_company_name') ? company.name : '',
                        shouldInclude(customizationFields, 'heading_right_company_address') ? 'Address: ' + company.address : '',
                        shouldInclude(customizationFields, 'heading_right_company_phone') ? 'Phone: ' + company.phone : '',
                        shouldInclude(customizationFields, 'heading_right_company_email') ? 'E-mail: ' + company.email : '',
                        shouldInclude(customizationFields, 'heading_right_vat_reg_number') ? 'VAT/GST Reg No: ' + company.vat_no : '',
                    ]
                }
            ]
        }
    }
    const getContent = (invoice, tableItems, barcode, btnFunc, isReturn, customizationFields) => {
        return  [
            {
                text: isReturn ? 'Purchase Bill Return' : 'Purchase Bill',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 0],
                bold: true,
                color: 'black',
            },

            {
                margin: [0, 10, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                text: 'Supplier',
                                color: 'black',
                                bold: true,

                            },

                            {
                                text: shouldInclude(customizationFields, 'body_top_left_supplier_name') ? invoice.contact.name : '',
                                alignment: 'left',
                                width: '50%'
                            },

                            {
                                text: shouldInclude(customizationFields, 'body_top_left_address') ? getProfileItemByField(invoice.contact.profile_items ?? [], 'address') : '',
                            },

                            {
                                text: shouldInclude(customizationFields, 'body_top_left_billing_address') ? getProfileItemByField(invoice.contact.profile_items ?? [], 'billing_address') : '',
                            },

                            {
                                text: shouldInclude(customizationFields, 'body_top_left_contact_address') ? `${invoice.contact.address ? invoice.contact.address : ''}` : ''
                            }
                        ]

                    },

                    {
                        alignment: 'right',
                        stack: [
                            shouldInclude(customizationFields, 'body_top_right_date') ? {
                                text: [
                                    {
                                        text: 'DATE: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: formatToDdMmYy(invoice.date),
                                    }
                                 ]
                            } : '',

                            (barcode && shouldInclude(customizationFields, 'body_top_right_bill_number')) ? {
                                text: [
                                    {
                                        text: 'PURCHASE REF: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: invoice.bill_number
                                    }
                                 ]
                            } : '',

                            (barcode && shouldInclude(customizationFields, 'body_top_right_barcode')) ? {
                                svg: barcode
                            } : '',

                            (btnFunc == 1 || !shouldInclude(customizationFields, 'body_top_right_ship_from')) ? '' : {
                                stack: [
                                    {
                                        text: invoice.location_id ? 'SHIP FROM:' : '',
                                        bold: true
                                    },

                                    {
                                        text: invoice.location_id
                                    }
                                ]
                            }
                        ]
                    },
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: getTableColumns(customizationFields).map(column => column.width),
                    body: []
                },
                layout: {
			        fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
		        }
		    },

            {
                columns: [
                    {
                        width: '65%',
                        text: shouldInclude(customizationFields, 'body_bottom_in_words_amount') ? [
                            {
                                text: 'In Words: ',
                                bold: true
                            },

                            {
                                text: invoice.total_amount ? currencyToWord(invoice.total_amount) : ''
                            }
                        ] : ''
                    },
                    {
                        table: {
                            widths: ['*', '*'],
                            alignment: 'right',
                            body: formatTotals(invoice, customizationFields)
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return 0.5;
                            },
                            vLineWidth: function (i, node) {
                                return 0.5;
                            }
                        }
                    }
                ],
                margin: [0, 10]
            },
            (invoice.description && shouldInclude(customizationFields, 'body_bottom_memo')) ? {
                columns: [
                    {
                        width: '100%',
                        text: [
                            {
                                text: 'Memo: ',
                                bold: true
                            },

                            {
                                text: invoice.description
                            }
                        ]
                    },
                ]
            } : null
        ]
    }
    const getFooter = (userName, qrcode, customizationFields, invoice, isDynamic, currentPage, pageCount) => {
        const signature = (currentPage === pageCount) ? getSignature(customizationFields, invoice, isDynamic) : null

        return {
            margin: [ 60, 0, 60, 0 ],
            stack: [
                signature,
                {
                    margin: [0, 10, 0, 0],
                    columns: [
                        {
                            columns: [
                                shouldInclude(customizationFields, 'footer_qrcode') ? {
                                    svg: qrcode
                                } : {},

                                {
                                    width: '90%',
                                    alignment: 'left',
                                    text: shouldInclude(customizationFields, 'footer_note') ? 'N.B: This is a system generated documents and requires no manual signature.' : '',
                                    margin: [5, 15, 0, 0],
                                    fontSize: 8
                                }
                            ]
                        },

                        {
                            width: '20%',
                            alignment: 'right',
                            fontSize: 8,
                            stack: shouldInclude(customizationFields, 'footer_printed_by') ? [
                                {
                                    text: 'Printed by',
                                    bold: true
                                },
                                {
                                    text: userName
                                },
                                {
                                    text: formatDate(new Date())
                                }
                            ] : []
                        }
                    ]
                }
            ].filter(Boolean)
        }
    }

    const getProfileItemByField = (profile_items, keyValue) => {
        const item = profile_items.find(item => item.field === keyValue);
        return (item) ? item.value : '';
    }

    const getItemName = (invoice, item, customizationFields) => {
        if (! invoice.has_item_detail) return item.head.name;
        if (! customizationFields) return item.product.name;
        if (! customizationFields.body_table_barcode_sku) return item.product.name;
        return formatNameWithCodes(item.product.name, [item.product.sku, item.product.barcode_sku]);
    }

    const formatTotals = (invoice, customizationFields) => {
        let totals = []

        if (shouldInclude(customizationFields, 'body_totals_table_bill_amount')) {
            totals.push([{ text: 'Bill Amount' }, { text: formatCurrency(invoice.subtotal_amount), alignment: 'right'}])
        }

        if (shouldInclude(customizationFields, 'body_totals_table_vat_amount')) {
            totals.push([ { text: 'VAT/GST Amount' }, {text:  formatCurrency(invoice.vat_amount), alignment: 'right' } ])
        }

        if (invoice.adjustment_amount && shouldInclude(customizationFields, 'body_totals_table_discount_adjustment')) {
            totals.push([ { text: 'Discount/Adjustment' }, {text:  formatCurrency(invoice.adjustment_amount), alignment: 'right' } ])
        }

        if (shouldInclude(customizationFields, 'body_totals_table_total_amount')) {
            totals.push([ { text: 'Total Bill Amount', bold: true }, { text: formatCurrency(invoice.total_amount), alignment: 'right'}])
        }

        if (invoice.paid_amount && shouldInclude(customizationFields, 'body_totals_table_paid_amount')) {
            totals.push([ { text: 'Amount Paid', bold: true }, { text: formatCurrency(invoice.paid_amount), alignment: 'right'}])
        }

        if (invoice.paid_amount && shouldInclude(customizationFields, 'body_totals_table_total_payable')) {
            totals.push([ { text: 'Total Payable', bold: true }, { text: formatCurrency(invoice.total_amount - invoice.paid_amount), alignment: 'right'}])
        }

        return totals
    }

    const formatInvoiceTerms = (terms) => {
        return  terms.map((item, index) => {
            return {
                text: `${item.full_desc}`
            }
        })
    }

    const getTableColumns = (customizationFields) => {
        const columns = [
            { key: 'body_table_particulars', width: '*', header: 'PARTICULARS', cell: (invoice, item) => ({ text: getItemName(invoice, item, customizationFields) + (item.description ? '\n' + item.description : '') + (item.sale_order_type ? '\n' +toCapitalizeFirst(item.sale_order_type) : '') }) },
            { key: 'body_table_qty', width: 'auto', header: 'QTY', cell: (invoice, item) => ({ text: invoice.has_item_detail ? formatCurrency(item.quantity) : '', alignment: 'right' }) },
            { key: 'body_table_rate', width: 'auto', header: 'RATE', cell: (invoice, item) => ({ text: invoice.has_item_detail ? formatCurrency(item.rate) : '', alignment: 'right' }) },
            { key: 'body_table_amount', width: 'auto', header: 'AMOUNT', cell: (invoice, item) => ({ text: formatCurrency(item.amount), alignment: 'right' }) },
            { key: 'body_table_discount', width: 'auto', header: 'DISCOUNT', cell: (invoice, item) => ({ text: formatCurrency(item.discount_amount), alignment: 'right' }) },
            { key: 'body_table_vat_amount', width: 'auto', header: 'VAT/GST AMOUNT', cell: (invoice, item) => ({ text: formatCurrency(item.vat_amount), alignment: 'right' }) },
            { key: 'body_table_total_amount', width: 'auto', header: 'TOTAL AMOUNT', cell: (invoice, item) => ({ text: formatCurrency(item.total_amount), alignment: 'right' }) },
        ]

        return columns.filter(column => shouldInclude(customizationFields, column.key))
    }

    const pushIntoTable = (doc, invoice, tableItems, btnFunc, customizationFields) => {
        const columns = getTableColumns(customizationFields);
        var flag = false;
        tableItems.forEach(item => {
            if( !flag ){
                doc.content[2].table.body.push(getTableHeader(columns));
                flag = true;
            }
            return doc.content[2].table.body.push(getRowData(invoice, item, columns));
        });
    }
    const getTableHeader = (columns) => {
        return columns.map(column => ({ text: column.header, alignment: column.width === '*' ? 'left' : 'right' }))
    }
    const getRowData = (invoice, item, columns) => {
        return columns.map(column => column.cell(invoice, item))
    }

    const getSingleSignatureContent = (title) => {
        return [
            {
                canvas: [
                    {
                        type: 'line',
                        x1: 0,
                        y1: 0,
                        x2: 130,
                        y2: 0,
                        lineWidth: 1
                    }
                ]
            },
            {
                margin: [ 0, 5, 0, 0 ],
                text: title,
                color: 'black',
                bold: true,
                alignment: 'left',
            }
        ]
    }
    const isSignatoryEmpty = (signatory) => signatory === null || signatory === undefined
    const getSignatorySignatureLine = () => ({
        canvas: [
            {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 130,
                y2: 0,
                lineWidth: 1
            }
        ],
        margin: [0, 15, 0, 0]
    })
    const getSignatoryMark = (signatory) => {
        if (!signatory.signature_photo64) return getSignatorySignatureLine()
        return { image: signatory.signature_photo64, width: 60, height: 30 }
    }
    const getDynamicSignatureContent = (title, signatory) => {
        if (isSignatoryEmpty(signatory)) return getSingleSignatureContent(title)

        return [
            getSignatoryMark(signatory),
            {
                margin: [ 0, 5, 0, 0 ],
                text: title,
                color: 'black',
                bold: true,
                alignment: 'left',
            },
            {
                text: signatory.name,
                fontSize: 8
            },
            signatory.designation ? { text: signatory.designation, fontSize: 8 } : null,
            { text: signatory.date, fontSize: 8 }
        ].filter(Boolean)
    }
    const getSignatoryStack = (title, signatory, isActive, isDynamic) => {
        if (!isActive) return []
        if (!isDynamic) return getSingleSignatureContent(title)
        return getDynamicSignatureContent(title, signatory)
    }
    const getSignature = (customizationFields, invoice, isDynamic) => {
        const hasPrepared = shouldIncludeSignature(customizationFields, 'signature_prepared_by');
        const hasApproved = shouldIncludeSignature(customizationFields, 'signature_approved_by');

        if (!hasPrepared && !hasApproved) return null;

        return {
            margin: [0, 0, 0, 15],
            columns: [
                {
                    width: '33%',
                    stack: getSignatoryStack('Prepared By', invoice.prepared_by, hasPrepared, isDynamic)
                },
                {
                    width: '34%',
                    text: ''
                },
                {
                    width: '33%',
                    stack: getSignatoryStack('Approved By', invoice.approved_by, hasApproved, isDynamic)
                }
            ]
        }
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
